import React, { useEffect, useState, createElement } from 'react';
import { CheckCircle2, Star, ShieldCheck, ArrowRight, Clock, BookOpen, Users, Award } from 'lucide-react';
// --- CONFIGURATION ---
const CHECKOUT_URL = 'https://checkout.sectordigital.online/cart/43977607938091:1';
const META_PIXEL_ID = '26257470350562748';
const IMAGES = {
  main: 'https://cdn.magicpatterns.com/uploads/fRSofQebGnbb7AxaeaWYXv/3.png',
  bonus1: 'https://cdn.magicpatterns.com/uploads/1gNsjRgNdXX1oTJCVuxzjS/4.png',
  bonus2: 'https://cdn.magicpatterns.com/uploads/nYx3iaEb3ZHjNvGBZ8tv2X/5.png'
};
// --- FAKE BUYERS DATA ---
const fakeBuyers = [{
  name: 'María F.',
  city: 'Córdoba',
  time: 'hace 2 minutos'
}, {
  name: 'Julieta S.',
  city: 'CABA',
  time: 'hace 5 minutos'
}, {
  name: 'Martín L.',
  city: 'Rosario',
  time: 'hace 12 minutos'
}, {
  name: 'Ana P.',
  city: 'Mendoza',
  time: 'hace 18 minutos'
}, {
  name: 'Carlos D.',
  city: 'La Plata',
  time: 'hace 25 minutos'
}, {
  name: 'Lucía M.',
  city: 'Mar del Plata',
  time: 'hace 31 minutos'
}, {
  name: 'Sofía R.',
  city: 'Tucumán',
  time: 'hace 42 minutos'
}];
// --- COMPONENTS ---
const scrollToPricing = (e: React.MouseEvent) => {
  e.preventDefault();
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
const ScrollButton = ({
  text = 'SÍ, QUIERO EL KIT AHORA',
  className = ''
}) => <button onClick={scrollToPricing} className={`inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold py-3 px-6 md:py-4 md:px-8 rounded-full text-base md:text-xl transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(245,158,11,0.4)] ${className}`} data-id="element-0">
    {text}
    <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-1" />
  </button>;
const CheckoutButton = ({
  text = 'SÍ, QUIERO EL KIT AHORA',
  className = ''
}) => <a href={CHECKOUT_URL} className={`inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold py-4 px-8 rounded-full text-lg md:text-xl transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(245,158,11,0.4)] ${className}`} data-id="element-2">
    {text}
    <ArrowRight className="w-6 h-6" data-id="element-3" />
  </a>;
const PurchasePopup = () => {
  const [currentBuyer, setCurrentBuyer] = useState(fakeBuyers[0]);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = fakeBuyers[Math.floor(Math.random() * fakeBuyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring interval
    const interval = setInterval(showPopup, 25000); // Show every 25 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 md:bottom-8 md:left-8 bg-white rounded-lg shadow-2xl p-4 flex items-center gap-4 z-50 animate-fade-in-up border border-slate-100 max-w-sm" data-id="element-4">
      <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-5">
        <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-6" />
      </div>
      <div data-id="element-7">
        <p className="text-sm text-slate-600" data-id="element-8">
          <span className="font-bold text-slate-900" data-id="element-9">{currentBuyer.name}</span>{' '}
          de {currentBuyer.city}
        </p>
        <p className="text-xs font-medium text-slate-800" data-id="element-10">
          Acaba de comprar el Kit Sesiones de Pareja
        </p>
        <p className="text-[10px] text-slate-400 mt-1" data-id="element-11">{currentBuyer.time}</p>
      </div>
    </div>;
};
export function App() {
  // Inject Meta Pixel
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${META_PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    return () => {
      // Cleanup if necessary
    };
  }, []);
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-800 selection:bg-amber-200" data-id="element-12">
      <PurchasePopup data-id="element-13" />

      {/* --- HERO SECTION --- */}
      <header className="bg-slate-900 text-white min-h-[100svh] flex flex-col justify-center px-4 py-8 relative overflow-hidden" data-id="element-14">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-amber-400 via-transparent to-transparent" data-id="element-15"></div>
        <div className="max-w-4xl mx-auto text-center relative z-10 flex flex-col items-center justify-center" data-id="element-16">
          <p className="text-amber-400 font-bold tracking-wider uppercase text-sm md:text-base mb-2 md:mb-4" data-id="element-17">
            AHORRÁ MESES DE PLANIFICACIÓN
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-3 md:mb-6" data-id="element-18">
            Organizá sesiones de pareja con estructura desde hoy.
          </h1>
          <p className="text-base md:text-2xl text-slate-300 mb-6 md:mb-10 max-w-3xl mx-auto font-light" data-id="element-19">
            El sistema práctico para psicólogos/as que te da el paso a paso para
            conducir sesiones de pareja con claridad, estructura y dirección
            clínica desde el día 1.
          </p>

          <div className="mb-6 md:mb-12 w-full" data-id="element-20">
            <img src={IMAGES.main} alt="KIT Sesiones de Pareja Principal" onClick={scrollToPricing} className="w-full max-w-[200px] md:max-w-md mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-500 cursor-pointer" data-id="element-21" />
          </div>

          <ScrollButton data-id="element-22" />

          <div className="mt-6 flex items-center justify-center gap-2 text-xs md:text-sm text-slate-400" data-id="element-23">
            <ShieldCheck className="w-4 h-4 text-amber-400" data-id="element-24" />
            <span data-id="element-25">Acceso inmediato · Pago único y seguro</span>
          </div>
        </div>
      </header>

      {/* --- PROBLEM SECTION (Video Removed) --- */}
      <section className="py-16 md:py-20 px-4 bg-white" data-id="element-26">
        <div className="max-w-3xl mx-auto" data-id="element-27">
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-10 leading-tight text-center" data-id="element-28">
            Chau al caos y la improvisación en consulta.
          </h2>
          <ul className="space-y-8" data-id="element-29">
            <li className="flex gap-4 items-start bg-slate-50 p-6 rounded-2xl border border-slate-100" data-id="element-30">
              <div className="bg-red-100 p-3 rounded-full flex-shrink-0" data-id="element-31">
                <Users className="w-6 h-6 text-red-600" data-id="element-32" />
              </div>
              <div data-id="element-33">
                <h3 className="font-bold text-xl text-slate-900 mb-2" data-id="element-34">
                  Intervenciones Profesionales
                </h3>
                <p className="text-slate-600 text-lg" data-id="element-35">
                  Qué decir exactamente cuando la pareja discute frente a vos y
                  la sesión pierde el rumbo.
                </p>
              </div>
            </li>
            <li className="flex gap-4 items-start bg-slate-50 p-6 rounded-2xl border border-slate-100" data-id="element-36">
              <div className="bg-amber-100 p-3 rounded-full flex-shrink-0" data-id="element-37">
                <BookOpen className="w-6 h-6 text-amber-600" data-id="element-38" />
              </div>
              <div data-id="element-39">
                <h3 className="font-bold text-xl text-slate-900 mb-2" data-id="element-40">
                  Formularios Clínicos
                </h3>
                <p className="text-slate-600 text-lg" data-id="element-41">
                  Organizá cada proceso con claridad. Descargás. Aplicás.
                  Trabajás con autoridad clínica.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </section>

      {/* --- BENEFITS SECTION --- */}
      <section className="py-20 px-4 bg-slate-900 text-white" data-id="element-42">
        <div className="max-w-4xl mx-auto text-center" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-44">
            UN SISTEMA QUE TE ORDENA <br data-id="element-45" />
            <span className="text-amber-400" data-id="element-46">(Y TE DA CONTROL CLÍNICO)</span>
          </h2>
          <p className="text-xl text-slate-300 mb-12" data-id="element-47">
            KIT Sesiones de Pareja™ (Sistema Práctico)
          </p>

          <p className="text-lg text-slate-300 mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-48">
            Creamos un sistema claro y aplicable para que dejes de reaccionar
            frente al conflicto, de depender del momento o de sentirte
            desbordado/a… y empieces a conducir sesiones de pareja con
            estructura profesional.
          </p>

          <div className="grid md:grid-cols-3 gap-8 text-left" data-id="element-49">
            <div className="bg-slate-800 p-8 rounded-2xl border border-slate-700" data-id="element-50">
              <Award className="w-10 h-10 text-amber-400 mb-4" data-id="element-51" />
              <h3 className="text-xl font-bold mb-3" data-id="element-52">
                MÁS AUTORIDAD EN CONSULTA
              </h3>
              <p className="text-slate-400" data-id="element-53">
                Entrás a cada sesión sabiendo cómo intervenir, cómo ordenar la
                dinámica y cómo avanzar.
              </p>
            </div>
            <div className="bg-slate-800 p-8 rounded-2xl border border-slate-700" data-id="element-54">
              <CheckCircle2 className="w-10 h-10 text-amber-400 mb-4" data-id="element-55" />
              <h3 className="text-xl font-bold mb-3" data-id="element-56">MÁS CALMA PROFESIONAL</h3>
              <p className="text-slate-400" data-id="element-57">
                Menos ansiedad frente a parejas difíciles. Menos sensación de “a
                ver qué pasa hoy”.
              </p>
            </div>
            <div className="bg-slate-800 p-8 rounded-2xl border border-slate-700" data-id="element-58">
              <BookOpen className="w-10 h-10 text-amber-400 mb-4" data-id="element-59" />
              <h3 className="text-xl font-bold mb-3" data-id="element-60">ESTRUCTURA REAL</h3>
              <p className="text-slate-400" data-id="element-61">
                No es teoría abstracta. Son herramientas clínicas listas para
                aplicar desde la próxima consulta.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* --- WHAT'S INCLUDED --- */}
      <section className="py-20 px-4 bg-slate-50" data-id="element-62">
        <div className="max-w-4xl mx-auto" data-id="element-63">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-slate-900 mb-16" data-id="element-64">
            QUÉ INCLUYE EL KIT SESIONES DE PAREJA
          </h2>
          <p className="text-center text-lg text-slate-600 mb-12" data-id="element-65">
            Todo lo que necesitás para trabajar con más orden, seguridad y
            dirección clínica en terapia vincular:
          </p>

          <div className="space-y-8" data-id="element-66">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 flex flex-col md:flex-row gap-6 items-start" data-id="element-67">
              <div className="bg-amber-100 text-amber-600 p-3 rounded-xl" data-id="element-68">
                <BookOpen className="w-8 h-8" data-id="element-69" />
              </div>
              <div data-id="element-70">
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-71">
                  Guía Principal: KIT Sesiones de Pareja
                </h3>
                <p className="text-slate-600" data-id="element-72">
                  El sistema completo para conducir sesiones de pareja difíciles
                  con claridad y método.
                </p>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 flex flex-col md:flex-row gap-6 items-start" data-id="element-73">
              <div className="bg-amber-100 text-amber-600 p-3 rounded-xl" data-id="element-74">
                <CheckCircle2 className="w-8 h-8" data-id="element-75" />
              </div>
              <div data-id="element-76">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-77">
                  Método de Reestructuración Vincular™
                </h3>
                <p className="text-slate-600 mb-4" data-id="element-78">
                  Una estructura profesional en 6 fases:
                </p>
                <ul className="grid md:grid-cols-2 gap-3 text-slate-700" data-id="element-79">
                  <li className="flex items-center gap-2" data-id="element-80">
                    <div className="w-1.5 h-1.5 bg-amber-500 rounded-full" data-id="element-81"></div>{' '}
                    Desactivar conflicto y recuperar control
                  </li>
                  <li className="flex items-center gap-2" data-id="element-82">
                    <div className="w-1.5 h-1.5 bg-amber-500 rounded-full" data-id="element-83"></div>{' '}
                    Detectar heridas y raíz del problema
                  </li>
                  <li className="flex items-center gap-2" data-id="element-84">
                    <div className="w-1.5 h-1.5 bg-amber-500 rounded-full" data-id="element-85"></div>{' '}
                    Intervención clínica guiada
                  </li>
                  <li className="flex items-center gap-2" data-id="element-86">
                    <div className="w-1.5 h-1.5 bg-amber-500 rounded-full" data-id="element-87"></div>{' '}
                    Reconstrucción del diálogo
                  </li>
                  <li className="flex items-center gap-2" data-id="element-88">
                    <div className="w-1.5 h-1.5 bg-amber-500 rounded-full" data-id="element-89"></div>{' '}
                    Nuevos acuerdos vinculares
                  </li>
                  <li className="flex items-center gap-2" data-id="element-90">
                    <div className="w-1.5 h-1.5 bg-amber-500 rounded-full" data-id="element-91"></div>{' '}
                    Consolidación y cierre terapéutico
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 flex flex-col md:flex-row gap-6 items-start" data-id="element-92">
              <div className="bg-amber-100 text-amber-600 p-3 rounded-xl" data-id="element-93">
                <Users className="w-8 h-8" data-id="element-94" />
              </div>
              <div data-id="element-95">
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-96">
                  Recursos de Intervención
                </h3>
                <p className="text-slate-600" data-id="element-97">
                  Para momentos donde la pareja se traba, discute o repite
                  siempre lo mismo.
                </p>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200 flex flex-col md:flex-row gap-6 items-start" data-id="element-98">
              <div className="bg-amber-100 text-amber-600 p-3 rounded-xl" data-id="element-99">
                <Award className="w-8 h-8" data-id="element-100" />
              </div>
              <div data-id="element-101">
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-102">
                  Herramientas Clínicas Aplicables
                </h3>
                <p className="text-slate-600" data-id="element-103">
                  Para organizar cada caso y trabajar con continuidad real.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-16 text-center" data-id="element-104">
            <ScrollButton data-id="element-105" />
          </div>
        </div>
      </section>

      {/* --- BONUSES SECTION --- */}
      <section className="py-20 px-4 bg-white border-y border-slate-200" data-id="element-106">
        <div className="max-w-5xl mx-auto" data-id="element-107">
          <div className="text-center mb-16" data-id="element-108">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-109">
              OFERTA ESPECIAL: BONUS PROFESIONALES
            </h2>
            <p className="text-xl text-amber-600 font-bold bg-amber-50 inline-block px-6 py-2 rounded-full" data-id="element-110">
              GRATIS POR EL DÍA DE HOY
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-111">
            {/* Bonus 1 */}
            <div className="bg-slate-50 rounded-3xl p-8 border border-slate-200 relative overflow-hidden group" data-id="element-112">
              <div className="absolute top-4 right-4 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider z-10" data-id="element-113">
                ¡Gratis Hoy!
              </div>
              <img src={IMAGES.bonus1} alt="50 Intervenciones para Terapia de Pareja" onClick={scrollToPricing} className="w-full max-w-[280px] mx-auto mb-8 drop-shadow-xl group-hover:-translate-y-2 transition-transform duration-300 cursor-pointer" data-id="element-114" />
              <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-115">
                BONUS #1
              </h3>
              <h4 className="text-xl font-bold text-amber-600 mb-4" data-id="element-116">
                50 Intervenciones para Terapia de Pareja
              </h4>
              <p className="text-slate-600" data-id="element-117">
                Frases, preguntas y recursos listos para usar cuando se
                interrumpen, discuten, no se escuchan o la sesión pierde rumbo.
              </p>
            </div>

            {/* Bonus 2 */}
            <div className="bg-slate-50 rounded-3xl p-8 border border-slate-200 relative overflow-hidden group" data-id="element-118">
              <div className="absolute top-4 right-4 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider z-10" data-id="element-119">
                ¡Gratis Hoy!
              </div>
              <img src={IMAGES.bonus2} alt="Pack Formularios Clínicos para Parejas" onClick={scrollToPricing} className="w-full max-w-[280px] mx-auto mb-8 drop-shadow-xl group-hover:-translate-y-2 transition-transform duration-300 cursor-pointer" data-id="element-120" />
              <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-121">
                BONUS #2
              </h3>
              <h4 className="text-xl font-bold text-amber-600 mb-4" data-id="element-122">
                Pack Formularios Clínicos para Parejas
              </h4>
              <p className="text-slate-600 mb-4" data-id="element-123">
                Incluye herramientas listas para aplicar:
              </p>
              <ul className="space-y-2 text-slate-700 text-sm" data-id="element-124">
                <li className="flex items-center gap-2" data-id="element-125">
                  <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-126" /> Historia
                  vincular inicial
                </li>
                <li className="flex items-center gap-2" data-id="element-127">
                  <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-128" /> Acuerdos
                  terapéuticos
                </li>
                <li className="flex items-center gap-2" data-id="element-129">
                  <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-130" />{' '}
                  Seguimiento clínico
                </li>
                <li className="flex items-center gap-2" data-id="element-131">
                  <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-132" /> Registro
                  de avances
                </li>
                <li className="flex items-center gap-2" data-id="element-133">
                  <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-134" /> Evaluación
                  inicial
                </li>
                <li className="flex items-center gap-2" data-id="element-135">
                  <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-136" /> Registro
                  de crisis
                </li>
                <li className="flex items-center gap-2" data-id="element-137">
                  <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-138" /> Reconexión
                  semanal
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* --- TARGET AUDIENCE & RESULTS --- */}
      <section className="py-20 px-4 bg-slate-900 text-white" data-id="element-139">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-16" data-id="element-140">
          <div data-id="element-141">
            <h2 className="text-3xl font-bold mb-8 text-amber-400" data-id="element-142">
              ESTE KIT ES PARA VOS SI...
            </h2>
            <ul className="space-y-4" data-id="element-143">
              {['Atendés parejas y querés hacerlo mejor.', 'Evitás parejas por inseguridad.', 'Atendés individual y querés expandirte.', 'Querés más herramientas clínicas reales.', 'Buscás especializarte profesionalmente.', 'Sentís que algunas sesiones se te van de las manos.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-144">
                  <CheckCircle2 className="w-6 h-6 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-145" />
                  <span className="text-lg text-slate-300" data-id="element-146">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-slate-800 p-8 rounded-3xl border border-slate-700" data-id="element-147">
            <h2 className="text-3xl font-bold mb-8 text-white" data-id="element-148">
              EL RESULTADO:
            </h2>
            <ul className="space-y-4" data-id="element-149">
              {['Entrás a sesión con más claridad.', 'Sabés cuándo intervenir.', 'Ordenás discusiones sin tomar partido.', 'Detectás la raíz del conflicto.', 'Guiás mejores acuerdos.', 'Trabajás con más calma profesional.'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-150">
                  <div className="w-2 h-2 bg-green-400 rounded-full" data-id="element-151"></div>
                  <span className="text-lg text-slate-200" data-id="element-152">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* --- PRICING / OFFER STACK --- */}
      <section id="pricing" className="py-12 md:py-24 px-4 bg-amber-50 scroll-mt-4" data-id="element-153">
        <div className="max-w-3xl mx-auto" data-id="element-154">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-amber-200" data-id="element-155">
            <div className="bg-slate-900 text-white text-center py-4 md:py-6 px-4" data-id="element-156">
              <h2 className="text-lg md:text-3xl font-bold leading-tight" data-id="element-157">
                TODO LO QUE NECESITÁS PARA CONDUCIR SESIONES DE PAREJA MEJOR
              </h2>
              <p className="text-amber-400 mt-1 md:mt-2 text-sm md:text-base" data-id="element-158">
                Un solo pago. Sin suscripciones. Tuyo para siempre.
              </p>
            </div>

            <div className="p-5 md:p-12" data-id="element-159">
              <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 md:mb-6 text-center border-b pb-3 md:pb-4" data-id="element-160">
                KIT SESIONES DE PAREJA
              </h3>

              <ul className="space-y-2 md:space-y-4 mb-6 md:mb-10" data-id="element-161">
                <li className="flex items-center gap-2 md:gap-3 text-sm md:text-lg text-slate-700" data-id="element-162">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-500 flex-shrink-0" data-id="element-163" />{' '}
                  Guía Principal Completa
                </li>
                <li className="flex items-center gap-2 md:gap-3 text-sm md:text-lg text-slate-700" data-id="element-164">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-500 flex-shrink-0" data-id="element-165" />{' '}
                  Método de Reestructuración Vincular™
                </li>
                <li className="flex items-center gap-2 md:gap-3 text-sm md:text-lg text-slate-700" data-id="element-166">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-500 flex-shrink-0" data-id="element-167" />{' '}
                  Recursos de Intervención Profesional
                </li>
                <li className="flex items-center gap-2 md:gap-3 text-sm md:text-lg font-bold text-slate-900 bg-amber-100 p-2 rounded-lg" data-id="element-168">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-amber-600 flex-shrink-0" data-id="element-169" />{' '}
                  BONUS: 50 Intervenciones para Pareja
                </li>
                <li className="flex items-center gap-2 md:gap-3 text-sm md:text-lg font-bold text-slate-900 bg-amber-100 p-2 rounded-lg" data-id="element-170">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-amber-600 flex-shrink-0" data-id="element-171" />{' '}
                  BONUS: Formularios Clínicos para Parejas
                </li>
              </ul>

              <div className="text-center mb-5 md:mb-8" data-id="element-172">
                <p className="text-slate-400 text-base md:text-xl line-through mb-1 md:mb-2 font-medium" data-id="element-173">
                  $49.990 ARS
                </p>
                <div className="flex items-center justify-center gap-2" data-id="element-174">
                  <span className="text-4xl md:text-6xl font-extrabold text-slate-900" data-id="element-175">
                    $19.990
                  </span>
                  <span className="text-lg md:text-xl font-bold text-slate-600 mt-2 md:mt-4" data-id="element-176">
                    ARS
                  </span>
                </div>
                <p className="text-slate-500 mt-1 md:mt-2 text-sm md:text-base font-medium" data-id="element-177">
                  Pago único · Sin cargos ocultos
                </p>
              </div>

              <div className="text-center" data-id="element-178">
                <CheckoutButton className="w-full py-3 md:py-5 text-lg md:text-xl" data-id="element-179" />
                <div className="mt-4 md:mt-6 flex flex-row items-center justify-center gap-2 md:gap-4 text-xs md:text-sm text-slate-600 font-medium" data-id="element-180">
                  <span className="flex items-center gap-1" data-id="element-181">
                    <Clock className="w-3 h-3 md:w-4 md:h-4" data-id="element-182" /> Acceso inmediato
                  </span>
                  <span data-id="element-183">•</span>
                  <span className="flex items-center gap-1" data-id="element-184">
                    <ShieldCheck className="w-3 h-3 md:w-4 md:h-4" data-id="element-185" /> Garantía 7
                    días
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- TESTIMONIALS --- */}
      <section className="py-20 px-4 bg-white" data-id="element-186">
        <div className="max-w-6xl mx-auto" data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-slate-900 mb-16" data-id="element-188">
            LO QUE DICEN OTROS COLEGAS
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-189">
            {/* Testimonial 1 */}
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200" data-id="element-190">
              <div className="flex gap-1 text-amber-400 mb-4" data-id="element-191">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-192" />)}
              </div>
              <p className="text-slate-700 italic mb-6" data-id="element-193">
                "Siempre evitaba parejas porque me sentía insegura. Este kit me
                dio estructura y hoy las conduzco con mucha más confianza."
              </p>
              <div data-id="element-194">
                <p className="font-bold text-slate-900" data-id="element-195">Valeria, 31 años</p>
                <p className="text-sm text-slate-500" data-id="element-196">Psicóloga en Córdoba</p>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200" data-id="element-197">
              <div className="flex gap-1 text-amber-400 mb-4" data-id="element-198">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-199" />)}
              </div>
              <p className="text-slate-700 italic mb-6" data-id="element-200">
                "Me pasaba que discutían toda la sesión y se iban igual. Ahora
                sé cómo intervenir sin perder dirección."
              </p>
              <div data-id="element-201">
                <p className="font-bold text-slate-900" data-id="element-202">Mariano, 36 años</p>
                <p className="text-sm text-slate-500" data-id="element-203">
                  Psicólogo en Buenos Aires
                </p>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200" data-id="element-204">
              <div className="flex gap-1 text-amber-400 mb-4" data-id="element-205">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-206" />)}
              </div>
              <p className="text-slate-700 italic mb-6" data-id="element-207">
                "Trabajo individual hace años, pero pareja era otro mundo. Este
                sistema me ordenó muchísimo."
              </p>
              <div data-id="element-208">
                <p className="font-bold text-slate-900" data-id="element-209">Luciana, 34 años</p>
                <p className="text-sm text-slate-500" data-id="element-210">Psicóloga en Rosario</p>
              </div>
            </div>

            {/* Testimonial 4 */}
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200" data-id="element-211">
              <div className="flex gap-1 text-amber-400 mb-4" data-id="element-212">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-213" />)}
              </div>
              <p className="text-slate-700 italic mb-6" data-id="element-214">
                "Solo con las intervenciones rápidas ya valió la compra."
              </p>
              <div data-id="element-215">
                <p className="font-bold text-slate-900" data-id="element-216">Nicolás, 39 años</p>
                <p className="text-sm text-slate-500" data-id="element-217">Psicólogo en Mendoza</p>
              </div>
            </div>

            {/* Testimonial 5 */}
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 md:col-span-2 lg:col-span-1" data-id="element-218">
              <div className="flex gap-1 text-amber-400 mb-4" data-id="element-219">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-220" />)}
              </div>
              <p className="text-slate-700 italic mb-6" data-id="element-221">
                "Antes dudaba de mis intervenciones, ahora tengo un mapa claro
                para cada sesión. Excelente material, muy práctico y directo al
                punto."
              </p>
              <div data-id="element-222">
                <p className="font-bold text-slate-900" data-id="element-223">Sofía, 42 años</p>
                <p className="text-sm text-slate-500" data-id="element-224">Psicóloga en La Plata</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- FOOTER --- */}
      <footer className="bg-slate-950 text-slate-400 py-12 px-4 text-center text-sm" data-id="element-225">
        <div className="max-w-4xl mx-auto space-y-4" data-id="element-226">
          <p data-id="element-227">© 2026 KIT Sesiones de Pareja. Todos los derechos reservados.</p>
          <p className="text-xs text-slate-500 max-w-2xl mx-auto" data-id="element-228">
            Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
            este sitio NO está respaldado por Facebook de ninguna manera.
          </p>
        </div>
      </footer>
    </div>;
}